export const presenterConfig = {
	emptyString: '-'
}